import addSettingApi from '@/api/addSetting/addSettingApi.js';
import moment from 'moment';

import passwordDialog from '@/components/addSetting/netScheduling/netSchedulingPasswordDialog.vue';
import errorDialog from '@/components/addSetting/netScheduling/netSchedulingErrorDialog.vue';

export default {
	name: 'net-shceduling',
	mixins: [],
	extends: {},
	components: { passwordDialog, errorDialog },
	props: [],
	data() {
		return {
			showSettingTable: false, // default
			settingInfo:{
				serviceType:'',
				schedulingRepeat:'',
				dayStartTimeFormated:'',
				dayEndTimeFormated:'',
				nightStartTimeFormated:'',
			},
			passwordInfo: {
				password:'',
			},
			dayTimeNotCompleteErr: false,
			settingTimeRequireErr: false,
			errorMessage:'',
			getNetSchedulingConfigResp:{
				isNotSubscribed:'',
				errorMessage:'',
				schedulingRepeat:'',
				schedulingActiveFlag:'',
				config:{
					dayStartTime:'',
					dayEndTime:'',
					nightStartTime:'',
					nightEndTime:'',
				}
			},
		};
	},
	computed: {
		
	},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {

		async checkPasswordAndSubmitChange(password) {

			this.passwordInfo.password = password;

			this.showPasswordDialog(false);

			const checkNetSchedulingPasswordResp = await addSettingApi.checkNetSchedulingPassword(this.passwordInfo);

			if (checkNetSchedulingPasswordResp != null) {
				this.updateAndShowErrorDialog(checkNetSchedulingPasswordResp);
				return;
			} else {
				const isSuccess = await addSettingApi.changeNetSchedulingConfig(this.settingInfo);
				if (isSuccess) {
					this.$router.push({name: 'gt-success', params: { title : '時間管理小褓姆', msg: '時間管理小褓姆已設定成功<br/>提醒您再重新更新一次畫面以得到最新設定狀態', returnName : 'net-scheduling' }});
				}
			}
		},

		async init() {

			this.getNetSchedulingConfigResp = await addSettingApi.getNetSchedulingConfig();

			if (!this.getNetSchedulingConfigResp) {
				return;
			}

			if (this.getNetSchedulingConfigResp.config) {
				this.settingInfo.schedulingRepeat = this.getNetSchedulingConfigResp.config.schedulingRepeat;
				if (this.getNetSchedulingConfigResp.config.dayStartTime) {
					this.settingInfo.dayStartTimeFormated = this.format2HHmm(this.getNetSchedulingConfigResp.config.dayStartTime);
				}
				if (this.getNetSchedulingConfigResp.config.dayEndTime) {
					this.settingInfo.dayEndTimeFormated = this.format2HHmm(this.getNetSchedulingConfigResp.config.dayEndTime);
				}
				if (this.getNetSchedulingConfigResp.config.nightStartTime) {
					this.settingInfo.nightStartTimeFormated = this.format2HHmm(this.getNetSchedulingConfigResp.config.nightStartTime);
				}
			}
		},

		changeConfig(serviceType) {

			switch(serviceType) {
				case 'CHANGE':
					if (!this.customValid()) {
						return;
					}
				default:
			}

			this.settingInfo.serviceType = serviceType;
			this.showPasswordDialog(true);
		},

		customValid() {

			// init
			this.dayTimeNotCompleteErr = false;
			this.settingTimeRequireErr = false;

			if (this.settingInfo.dayStartTimeFormated == '' && this.settingInfo.dayEndTimeFormated == '' && this.settingInfo.nightStartTimeFormated == '') {
				this.settingTimeRequireErr = true;
				return false;
			} else {
				this.settingTimeRequireErr = false;
			}

			if ((this.settingInfo.dayStartTimeFormated == '' && this.settingInfo.dayEndTimeFormated != '') 
			|| (this.settingInfo.dayStartTimeFormated != '' && this.settingInfo.dayEndTimeFormated == '')) {
				this.dayTimeNotCompleteErr = true;
				return false;
			} else {
				this.dayTimeNotCompleteErr = false;
			}

			return true;
		},

		showCurrentSetting() {
			if ((this.getNetSchedulingConfigResp.config.dayStartTime && this.getNetSchedulingConfigResp.config.dayEndTime)
			 || (this.getNetSchedulingConfigResp.config.nightStartTime && this.getNetSchedulingConfigResp.config.nightEndTime)) {
				 return true;
			}
			return false;
		},

		showPasswordDialog(isShow) {

			if (isShow) {
				// init
				this.passwordInfo.password = '';
			}

			let dialog = this.$refs.passwordDialog.$el;
			$(dialog).modal(isShow ? 'show' : 'hide');
		},

		showErrorDialog(isShow) {
			let dialog = this.$refs.errorDialog.$el;
			$(dialog).modal(isShow ? 'show' : 'hide');
		},

		updateAndShowErrorDialog(msg) {
			this.errorMessage = msg;
			this.showErrorDialog(true);
		},

		format2HHmm(date) {
			if (date) {
				return moment(date).format('HH:mm');
			}
			return "";
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/addSetting/netScheduling/netScheduling.js